import { commitMutation, graphql } from 'react-relay';
import type { PayloadError } from 'relay-runtime';
import { RelayEnvironment } from '../relay-env';
import type {
  SyncService_Mutation,
  SyncService_Mutation$data,
  SyncService_Mutation$variables,
} from './__generated__/SyncService_Mutation.graphql';

export type { SyncService_Mutation$variables } from './__generated__/SyncService_Mutation.graphql';
export const SyncServiceMutation = graphql`
  mutation SyncService_Mutation($input: SyncServiceInput!) {
    syncService(input: $input) {
      status
      nextAvailableTime
      nextRelativeAvailableTime
    }
  }
`;

export const statusToast = (data: SyncService_Mutation$data['syncService']) => {
  const nextTimeStr = data?.nextRelativeAvailableTime
    ? ` - next manual sync available in ${data?.nextRelativeAvailableTime}`
    : '';

  let ret = {
    level: 'error',
    message: `Sync failed${nextTimeStr}`,
  };
  switch (data?.status) {
    case 'IN_PROGRESS':
      ret = {
        level: 'error',
        message: `Sync already in progress${nextTimeStr}`,
      };
      break;
    case 'REGISTERED':
      ret = {
        level: 'success',
        message: `Sync started${nextTimeStr}`,
      };
      break;

    case 'TIME_NOT_ELAPSED':
      ret = {
        level: 'error',
        message: `Sync not available yet${nextTimeStr}`,
      };
      break;
  }
  return ret;
};

export const syncServiceMutation = (
  input: SyncService_Mutation$variables['input'],
  onCompleted?: (response: SyncService_Mutation$data, errors: readonly PayloadError[] | null | undefined) => void
) => {
  commitMutation<SyncService_Mutation>(RelayEnvironment, {
    mutation: SyncServiceMutation,
    variables: { input },
    onCompleted: (response: SyncService_Mutation$data, errors) => {
      if (response?.syncService?.status === 'REGISTERED') {
        // call the sync service again as a trigger to start the sync
        // moving it from pending to in-progress
        syncServiceMutation(input);
      }

      onCompleted?.(response, errors);
    },
  });
};
